import React from "react";
import { Form } from "@redriver/cinnamon";
import { getContractJobTypes } from "./actions";

const ContractJobTypesDropdown = ({ ...props }) => (
  <Form.Dropdown lookupAction={getContractJobTypes} {...props} />
);

export default ContractJobTypesDropdown;
